import { v } from "convex/values";
import {
  internalControl,
  defineTableWithInternalControl,
} from "../../lib/shared/validators";

export const attachmentEntityType = v.union(
  v.literal("work_orders"),
  v.literal("clients"),
  v.literal("invoices"),
  v.literal("products"),
  v.literal("services"),
  v.literal("quotations"),
  v.literal("sales"),
  v.literal("suppliers"),
  v.literal("equipment"),
  v.literal("personnel"),
  v.literal("document_records"),
  v.literal("stock_transfers"),
);

export const attachmentFileType = v.union(
  v.literal("image"),
  v.literal("document"),
  v.literal("photo"),
  v.literal("spreadsheet"),
  v.literal("other"),
);

export const validatorAttachment = v.object({
  entityType: attachmentEntityType,
  entityId: v.string(),
  storageId: v.id("_storage"),
  type: attachmentFileType,
  name: v.string(),
  description: v.optional(v.string()),
  mimeType: v.optional(v.string()),
  fileSize: v.optional(v.number()),
  tags: v.optional(v.array(v.string())),
  metadata: v.optional(
    v.object({
      width: v.optional(v.number()),
      height: v.optional(v.number()),
      duration: v.optional(v.number()),
      pages: v.optional(v.number()),
      thumbnail: v.optional(v.id("_storage")),
    }),
  ),
  internalControl,
});

export const attachments = defineTableWithInternalControl(validatorAttachment)
  .index("by_entity", ["entityType", "entityId"])
  .index("by_entity_and_type", ["entityType", "entityId", "type"])
  .index("by_storage_id", ["storageId"])
  .index("by_company_and_entity", [
    "internalControl.companyId",
    "entityType",
    "entityId",
  ])
  .index("by_type", ["type"])
  .searchIndex("search_attachments", {
    searchField: "name",
    filterFields: [
      "internalControl.companyId",
      "entityType",
      "type",
    ],
  });
